/* eslint-disable */
import findOutMore from "@/static/additionalInfo.json";

export function getMarkerDetails(markerCode) {
  return findOutMore.find(
    (f) => {
      if (f.Code) {
        const normalisedCode = f.Code.includes('[') ? JSON.parse(f.Code) : [f.Code];

        return normalisedCode.map((c) => c.toLowerCase()).includes(markerCode.toLowerCase());
      }
      return false;
    }
  );
}

export function getLowestRangeForPanel(panel) {
  const stages = panel.markers.map((marker) => marker?.resultRangeStage?.name);
  if (stages.includes("rangeLow") || stages.includes("rangeHigh")) {
    return "rangeLow";
  }
  if (stages.includes("rangeLowNormal") || stages.includes("rangeHighNormal")) {
    return "rangeLowNormal";
  }
  return "rangeNormal";
}
